import type { ColumnDef } from '@tanstack/react-table'
import { IssueDataTable, TableSkeleton } from '@/components/tables/data-table'
import { ISSUE_COLUMNS } from '@/components/tables/issue-columns'
import type { BulkKind } from '@/components/tables/bulk-action-bar'
import type { WorkIssue } from '@/types/github'

export { TableSkeleton }

/** Plain (sort-free) issue list shared by /q, /me, /my-verifications, /closed
 *  and /rollouts — a thin preset over the shared IssueDataTable. */
export function IssueTable({
  issues,
  columns = ISSUE_COLUMNS,
  emptyTitle,
  emptyHint,
  bulkKind,
  searchable,
}: {
  issues: WorkIssue[]
  columns?: ColumnDef<WorkIssue>[]
  emptyTitle?: string
  emptyHint?: string
  bulkKind?: BulkKind
  searchable?: boolean
}) {
  return (
    <IssueDataTable
      issues={issues}
      columns={columns}
      bulkKind={bulkKind}
      searchable={searchable}
      emptyTitle={emptyTitle}
      emptyHint={emptyHint}
    />
  )
}
